export default "__VITE_ASSET__gp3JnNBI__"